/**
 * Workflow Run Complete Renderer
 *
 * @module WorkflowRunCompleteRenderer
 *
 * Custom renderer for "workflow-run-complete" notification type.
 * Shows success/failure icon and a link to the flow.
 */

import React from 'react';
import { CheckCircle, XCircle } from '@phosphor-icons/react';
import { Link } from '@tanstack/react-router';
import { registerNotificationRenderer } from '../NotificationRegistry';
import type { NotificationRendererProps } from '../NotificationRegistry';

function WorkflowRunCompleteRenderer({ notification }: NotificationRendererProps) {
  const { workflowId, status } = notification.data as {
    workflowId?: string;
    runId?: string;
    status?: string;
  };

  const isSuccess = status === 'success';

  return (
    <div className="flex items-start gap-2">
      {isSuccess ? (
        <CheckCircle size={18} weight="fill" className="mt-0.5 shrink-0 text-green-500" />
      ) : (
        <XCircle size={18} weight="fill" className="mt-0.5 shrink-0 text-red-500" />
      )}
      <div>
        <p className="text-sm text-neutral-900 dark:text-neutral-100">
          {notification.title}
        </p>
        {workflowId && (
          <Link
            to="/flows/$workflowId"
            params={{ workflowId }}
            className="mt-1 text-xs text-blue-600 hover:text-blue-700 dark:text-blue-400"
          >
            View flow
          </Link>
        )}
      </div>
    </div>
  );
}

registerNotificationRenderer('workflow-run-complete', WorkflowRunCompleteRenderer);
